/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Title_LeadInputs */

const en_auth_signup_title_lead = /** @type {(inputs: Auth_Signup_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

const pl_auth_signup_title_lead = /** @type {(inputs: Auth_Signup_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do`)
};

/**
* | output |
* | --- |
* | "Join" |
*
* @param {Auth_Signup_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title_lead = /** @type {((inputs?: Auth_Signup_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_title_lead(inputs)
	return en_auth_signup_title_lead(inputs)
});